// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1U6Ll","tab":"Tabs_tab__BCVOi","tabActive":"Tabs_tabActive__2JUtd"};